import { Record, Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { list_type, int32_type, record_type, option_type, string_type, class_type, union_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { SKU_$reflection } from "./Shopfoo.Domain.Types/Common.js";
import { BookAuthor_$reflection, BazaarCategory_$reflection } from "./Shopfoo.Domain.Types/Catalog.js";
import { toList as toList_1, ofSeq } from "./fable_modules/fable-library-js.4.24.0/Map.js";
import { indexed, toArray, append, empty, singleton, collect, exists, map, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { equals, compare } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { reduce, isEmpty, choose } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { Option_ofPair } from "./Shopfoo.Common/Common.js";
import { ofList } from "./fable_modules/fable-library-js.4.24.0/Set.js";
import { matches as matches_1, split, escape, create } from "./fable_modules/fable-library-js.4.24.0/RegExp.js";
import { item } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { $007CNotEmpty$007C_$007C, $007CNullOrWhiteSpace$007C_$007C } from "./Shopfoo.Common/String.js";
import { rangeDouble } from "./fable_modules/fable-library-js.4.24.0/Range.js";
import { TranslationPages_Product__StoreCategoryOf_Z2CEE261C, AppTranslations__get_Product } from "./Shopfoo.Shared/Translations.js";

export class CaseMatching extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CaseSensitive", "CaseInsensitive"];
    }
}

export function CaseMatching_$reflection() {
    return union_type("Shopfoo.Client.Search.CaseMatching", [], CaseMatching, () => [[], []]);
}

export function CaseSensitiveIf(condition) {
    if (condition) {
        return new CaseMatching(0, []);
    }
    else {
        return new CaseMatching(1, []);
    }
}

export class Column extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Num", "SKU", "Name", "Description", "BazaarCategory", "BookSubtitle", "BookAuthors", "BookTags"];
    }
}

export function Column_$reflection() {
    return union_type("Shopfoo.Client.Search.Column", [], Column, () => [[], [], [], [], [], [], [], []]);
}

export class Highlighting extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Active", "None"];
    }
}

export function Highlighting_$reflection() {
    return union_type("Shopfoo.Client.Search.Highlighting", [], Highlighting, () => [[], []]);
}

export function Highlighting_ActiveIf_Z1FBCCD16(condition) {
    if (condition) {
        return new Highlighting(0, []);
    }
    else {
        return new Highlighting(1, []);
    }
}

export class SearchConfig extends Record {
    constructor(Columns, CaseMatching, Highlighting, Term) {
        super();
        this.Columns = Columns;
        this.CaseMatching = CaseMatching;
        this.Highlighting = Highlighting;
        this.Term = Term;
    }
}

export function SearchConfig_$reflection() {
    return record_type("Shopfoo.Client.Search.SearchConfig", [], SearchConfig, () => [["Columns", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [Column_$reflection()])], ["CaseMatching", CaseMatching_$reflection()], ["Highlighting", Highlighting_$reflection()], ["Term", option_type(string_type)]]);
}

export class SearchTarget extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Description", "Title", "SKU", "BazaarCategory", "BookSubtitle", "BookAuthor", "BookTag"];
    }
}

export function SearchTarget_$reflection() {
    return union_type("Shopfoo.Client.Search.SearchTarget", [], SearchTarget, () => [[["Item", string_type]], [["Item", string_type]], [["Item", SKU_$reflection()]], [["Item", BazaarCategory_$reflection()]], [["Item", string_type]], [["Item", BookAuthor_$reflection()]], [["Item", string_type]]]);
}

export class MatchType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TextMatch", "NoMatch"];
    }
}

export function MatchType_$reflection() {
    return union_type("Shopfoo.Client.Search.MatchType", [], MatchType, () => [[], []]);
}

export class MatchText extends Record {
    constructor(Index, MatchType, Text$) {
        super();
        this.Index = (Index | 0);
        this.MatchType = MatchType;
        this.Text = Text$;
    }
}

export function MatchText_$reflection() {
    return record_type("Shopfoo.Client.Search.MatchText", [], MatchText, () => [["Index", int32_type], ["MatchType", MatchType_$reflection()], ["Text", string_type]]);
}

export class SearchTargetResult extends Record {
    constructor(Target, Text$, Matches, Highlighting) {
        super();
        this.Target = Target;
        this.Text = Text$;
        this.Matches = Matches;
        this.Highlighting = Highlighting;
    }
}

export function SearchTargetResult_$reflection() {
    return record_type("Shopfoo.Client.Search.SearchTargetResult", [], SearchTargetResult, () => [["Target", SearchTarget_$reflection()], ["Text", string_type], ["Matches", list_type(MatchText_$reflection())], ["Highlighting", Highlighting_$reflection()]]);
}

export class SearchStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NoMatch", "Matches"];
    }
}

export function SearchStatus_$reflection() {
    return union_type("Shopfoo.Client.Search.SearchStatus", [], SearchStatus, () => [[], [["Item", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [Column_$reflection()])]]]);
}

export function SearchResultModule_build(searchConfig, f) {
    return ofSeq(toList(delay(() => map((column) => [column, f(column)], searchConfig.Columns))), {
        Compare: compare,
    });
}

export function SearchResultModule_status(searchResult) {
    const _arg_1 = choose((tupledArg) => Option_ofPair(exists((x) => equals(x.MatchType, new MatchType(0, [])), collect((_arg) => _arg.Matches, tupledArg[1])), tupledArg[0]), toList_1(searchResult));
    if (isEmpty(_arg_1)) {
        return new SearchStatus(0, []);
    }
    else {
        return new SearchStatus(1, [ofList(_arg_1, {
            Compare: compare,
        })]);
    }
}

export class Searcher {
    constructor(config, translations) {
        this.config = config;
        this.translations = translations;
    }
}

export function Searcher_$reflection() {
    return class_type("Shopfoo.Client.Search.Searcher", undefined, Searcher);
}

export function Searcher_$ctor_Z1481DE65(config, translations) {
    return new Searcher(config, translations);
}

export function Searcher__Product(_, product, column) {
    return toList(delay(() => {
        const matchValue = product.Category;
        switch (column.tag) {
            case 1:
                return singleton(Searcher__searchSKU_2648A66C(_, product.SKU));
            case 2:
                return singleton(Searcher__searchTitle_Z721C83C5(_, product.Title));
            case 3:
                return singleton(Searcher__searchDescription_Z721C83C5(_, product.Description));
            case 4:
                if (matchValue.tag === 1) {
                    return empty();
                }
                else {
                    return singleton(Searcher__searchBazaarCategory_Z2CEE261C(_, matchValue.fields[0].Category));
                }
            case 5:
                if (matchValue.tag === 1) {
                    return singleton(Searcher__searchBookSubtitle_Z721C83C5(_, matchValue.fields[0].Subtitle));
                }
                else {
                    return empty();
                }
            case 6:
                if (matchValue.tag === 1) {
                    return map((author) => Searcher__searchBookAuthor_Z7849B29D(_, author), matchValue.fields[0].Authors);
                }
                else {
                    return empty();
                }
            case 7:
                if (matchValue.tag === 1) {
                    return map((tag) => Searcher__searchBookTag_Z721C83C5(_, tag), matchValue.fields[0].Tags);
                }
                else {
                    return empty();
                }
            default: {
                return empty();
            }
        }
    }));
}

export function Searcher__Target_4B4D257A(_, target, text) {
    return Searcher__search(_, target, text);
}

export function Searcher__searchRegexOptions_Z5E20C3A7(this$, caseMatching) {
    return reduce((x, y) => (x | y), toList(delay(() => append(singleton(2), delay(() => (equals(caseMatching, new CaseMatching(1, [])) ? singleton(1) : empty()))))));
}

export function Searcher__computeMatches_Z721C83C5(this$, text) {
    return delay(() => {
        const matchValue = this$.config.Term;
        let matchResult, term;
        if (matchValue != null) {
            if ($007CNotEmpty$007C_$007C(matchValue) != null) {
                matchResult = 0;
                term = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                const regex = create(escape(term), Searcher__searchRegexOptions_Z5E20C3A7(this$, this$.config.CaseMatching));
                const parts = split(regex, text);
                const matches = toArray(matches_1(regex, text));
                return collect((i) => {
                    let matchValue_1;
                    return append((matchValue_1 = item(i, parts), ($007CNullOrWhiteSpace$007C_$007C(matchValue_1) != null) ? (empty()) : singleton([new MatchType(1, []), matchValue_1])), delay(() => ((i < matches.length) ? singleton([new MatchType(0, []), item(i, matches)[0]]) : empty())));
                }, rangeDouble(0, 1, parts.length - 1));
            }
            default: {
                if (matchValue != null) {
                }
                return empty();
            }
        }
    });
}

export function Searcher__search(this$, target, text) {
    return new SearchTargetResult(target, text, toList(delay(() => collect((matchValue) => singleton(new MatchText(matchValue[0], matchValue[1][0], matchValue[1][1])), indexed(Searcher__computeMatches_Z721C83C5(this$, text))))), this$.config.Highlighting);
}

export function Searcher__searchText(this$, targetCase, text) {
    return Searcher__search(this$, targetCase(text), text);
}

export function Searcher__searchObject(this$, targetCase, object, getText) {
    return Searcher__search(this$, targetCase(object), getText(object));
}

export function Searcher__searchSKU_2648A66C(this$, sku) {
    return Searcher__searchObject(this$, (Item) => (new SearchTarget(2, [Item])), sku, (_arg) => _arg.Value);
}

export function Searcher__searchTitle_Z721C83C5(this$, title) {
    return Searcher__searchText(this$, (Item) => (new SearchTarget(1, [Item])), title);
}

export function Searcher__searchDescription_Z721C83C5(this$, description) {
    return Searcher__searchText(this$, (Item) => (new SearchTarget(0, [Item])), description);
}

export function Searcher__searchBazaarCategory_Z2CEE261C(this$, category) {
    let objectArg;
    return Searcher__searchObject(this$, (Item) => (new SearchTarget(3, [Item])), category, (objectArg = AppTranslations__get_Product(this$.translations), (storeCategory) => TranslationPages_Product__StoreCategoryOf_Z2CEE261C(objectArg, storeCategory)));
}

export function Searcher__searchBookSubtitle_Z721C83C5(this$, subtitle) {
    return Searcher__searchText(this$, (Item) => (new SearchTarget(4, [Item])), subtitle);
}

export function Searcher__searchBookAuthor_Z7849B29D(this$, author) {
    return Searcher__searchObject(this$, (Item) => (new SearchTarget(5, [Item])), author, (_arg) => _arg.Name);
}

export function Searcher__searchBookTag_Z721C83C5(this$, tag) {
    return Searcher__searchText(this$, (Item) => (new SearchTarget(6, [Item])), tag);
}

